export default {"src":"/_next/static/media/three-ellipse-white.109ac60d.svg","height":32,"width":22};